import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
  toast,
} from "@/components/kit";
import { peekImportOrderPhase13Draft } from "@/modules/inventory/presentation/lib/import-prefill-phase13";
import { useCreateProduct, useProductCategoriesQuery } from "../api/queries";
import { ProductForm } from "../ui/ProductForm";
import { ProductFormPageHeader } from "../ui/ProductFormPageHeader";

export function ProductCreatePage() {
  const nav = useNavigate({ from: "/app/products/new" });
  const categories = useProductCategoriesQuery();
  const create = useCreateProduct();
  const importDraft = peekImportOrderPhase13Draft();

  return (
    <>
      <Header />
      <Main>
        <ProductFormPageHeader
          title="ເພີ່ມສິນຄ້າ"
          subtitle="ເພີ່ມສິນຄ້າໃໝ່ເຂົ້າຄລັງອ້າງອີງ — ເພີ່ມຕົວເລືອກຫຼັງຈາກບັນທຶກ"
          onBack={() =>
            nav({
              to: importDraft?.returnTo ?? "/app/products",
            })
          }
        />

        {importDraft ? (
          <div className="mb-4 rounded-xl border border-amber-600/30 bg-amber-500/10 px-4 py-3 text-sm">
            <p className="font-medium">ກຳລັງສ້າງສິນຄ້າເພື່ອໃບສັ່ງນຳເຂົ້າ</p>
            <p className="text-muted-foreground mt-1 text-xs">
              ບັນທຶກສິນຄ້າ ແລ້ວເພີ່ມຕົວເລືອກ — ລະບົບຈະພາກັບໄປໃບສັ່ງອັດຕະໂນມັດ
            </p>
          </div>
        ) : null}

        {categories.data?.data?.length ? (
          <ProductForm
            categories={categories.data.data}
            submitting={create.isPending}
            onSubmit={async (vals) => {
              try {
                const created = await create.mutateAsync(vals);
                toast.success("ສ້າງສິນຄ້າສຳເລັດ — ເພີ່ມຕົວເລືອກຕໍ່ໄດ້");
                nav({
                  to: "/app/products/$id/edit",
                  params: { id: created.id },
                });
              } catch {
                toast.error("ສ້າງສິນຄ້າລົ້ມເຫຼວ");
              }
            }}
          />
        ) : (
          <div className="brand-card p-8">
            <Empty>
              <EmptyHeader>
                <EmptyTitle>ຍັງບໍ່ມີຫມວດຫມູ່</EmptyTitle>
                <EmptyDescription>
                  ກະລຸນາເພີ່ມຫມວດຫມູ່ກ່ອນ (ຈາກໜ້າລາຍການສິນຄ້າ)
                </EmptyDescription>
              </EmptyHeader>
            </Empty>
          </div>
        )}
      </Main>
    </>
  );
}
